import React from 'react';
import { Line } from '../Lines';
import { Price } from '../Price';

const StandardPriceGroup = ({ pricing }) => {
  const { standardVehiclePrice, unknownPriceDisplay } = pricing;

  if (unknownPriceDisplay) {
    return (
      <Line
        labelKey="standard.price"
        price={<Price>{unknownPriceDisplay}</Price>}
        className="standard-features-total"
      />
    );
  }

  return (
    <Line
      labelKey="standard.price"
      price={standardVehiclePrice.text}
      className="standard-features-total"
    />
  );
};

export default StandardPriceGroup;
